export default "__VITE_PUBLIC_ASSET__bf6e6109__"